























































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { QuestelServicesClient } from '@questelservices/common';
import { alert } from 'devextreme/ui/dialog';
import notify from 'devextreme/ui/notify';
import { DxButton } from 'devextreme-vue/button';
import { DxList } from 'devextreme-vue/list';
import { DxLoadPanel } from 'devextreme-vue/load-panel';
import { DxSelectBox } from 'devextreme-vue/select-box';
import FileSaver from 'file-saver';
import { SelectOption } from '@/models/SelectOption';
import { BatchDto } from '@/models/batch/BatchDto';
import { ClientEbillingReportDto } from '@/models/e-billing/ClientEbillingReportDto';
import { ClientEbillingReportRequestDto } from '@/models/e-billing/ClientEbillingReportRequestDto';
import { EbillingReportsRequestDto } from '@/models/e-billing/EbillingReportsRequestDto';
import { ClientService } from '@/service/ClientService';
import { BatchService } from '@/service/BatchService';
import { EbillingService } from '@/service/EbillingService';
import String from '@/utilities/String';

@Component({
  components: {
    DxButton,
    DxList,
    DxLoadPanel,
    DxSelectBox
  }
})
export default class EBilling extends Vue {
  private readonly batchService: BatchService = new BatchService();
  private readonly client: QuestelServicesClient = new QuestelServicesClient(this.$store, '');
  private readonly clientService: ClientService = new ClientService();
  private readonly ebillingService: EbillingService = new EbillingService();

  private batches: BatchDto[] = [];
  private clients: SelectOption[] = [];
  private downloadInProgress: boolean = false;
  private reports: ClientEbillingReportDto[] = [];
  private selectedBatch: Guid | null = null;
  private selectedClient: Guid | null = null;
  private selectedReports: ClientEbillingReportDto[] = [];

  @Watch('selectedClient')
  private async onSelectedClientChanged() {
    this.selectedBatch = null;
    this.batches = [];

    await this.loadBatches();

    if (this.batches.length > 0) {
      this.selectedBatch = this.batches[0].BatchId;
    }
  }

  @Watch('selectedBatch')
  private async onSelectedBatchChanged() {
    this.reports = [];

    if (this.selectedBatch != null) {
      this.reports = await this.batchService.getEbillingReports(this.selectedBatch);
    }
  }

  async created() {
    await this.loadData();
  }

  private async loadData() {
    this.clients = await this.clientService.getEbillerSelectOptions();
  }

  private async loadBatches() {
    if (this.selectedClient != null) {
      this.batches = await this.batchService.getClosedClientBatches(this.selectedClient);
    }
  }

  private downloadReports() {
    if (this.selectedBatch == null) {
      return;
    }

    let request: EbillingReportsRequestDto = {
      BatchId: this.selectedBatch,
      ReportsToGenerate: this.selectedReports.map<ClientEbillingReportRequestDto>(r => {
        return {
          ClientEbillingReportId: r.ClientEbillingReportId,
          AgentId: r.AgentId
        };
      })
    };

    this.downloadInProgress = true;
    this.ebillingService.getEbillingReports(request)
      .then(downloadAuthorization => {
        this.client.download(downloadAuthorization.Url, downloadAuthorization.Token)
          .then((downloadResult: Response) => {
            if (downloadResult.ok) {
              let filename: string | undefined = undefined;
              let filenameHeader = downloadResult.headers.get('Filename');

              if (filenameHeader != null) {
                filename = filenameHeader;
              }

              if (filename != null) {
                filename = decodeURIComponent(filename);
              }

              downloadResult.blob().then(data => {
                FileSaver.saveAs(data, filename);
              });

              notify('Report printing complete', 'success', 4000);
            } else {
              this.handleErrorResponse('An error occurred downloading the report(s).');
            }
          })
          .catch(reason => {
            this.handleErrorResponse('An error occurred downloading the report(s).');
          });
      })
      .catch(reason => {
        if(reason.Message == "No reports generated.") {
          this.handleNoReportsAvailable();
        }
        else {
          this.handleErrorResponse('An error occurred generating the report(s).');
        }
      })
      .finally(() => {
        this.downloadInProgress = false;
      });
  }

  private handleErrorResponse(message: string) {
    alert(message, 'Error');
  }

  private handleNoReportsAvailable(){
    let batchName = this.batches.find(x => x.BatchId == this.selectedBatch);
    let clientName = this.clients.find(x => x.value == this.selectedClient);
    let reportTypes = this.reports.filter(x => this.selectedReports.some(z => x.ClientEbillingReportId == z.ClientEbillingReportId)).map(x => x.DisplayName);
    let reportMessage = ""
    if(reportTypes.length > 2) {
      reportMessage = `${reportTypes[0]} and ${reportTypes.length - 1} other reports`;
    }
    else {
      reportMessage = `${reportTypes.join(",")} report(s)`;
    }
    let message = `${clientName!.text} has no ${reportMessage} in batch ${batchName!.BatchName}`;
    alert(message, 'Report printing cancelled');
  }

  private batchDisplayExpression(batch?: BatchDto) {
    if (batch == null) {
      return '';
    }

    let result = String.removeTrailingZeros(batch.BatchName);
    return result == null ? '' : result;
  }
}
